import { useRef, useState, useEffect, ReactNode } from 'react';
import styles from './styles.module.css';
import ToolbarIcons from '@/icons/toolbar';
import RenderHelpBox from '../RenderHelpBox';
import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';

export interface SelectItem {
  id: string | number;
  title?: string;
  name?: string;
  color?: string;
}

export interface SelectProps {
  list: SelectItem[] | any;
  title?: string;
  id?: string | number;
  fillFormFunction?: (id: string | number) => void;
  chooseItem?: (item: SelectItem) => void;

  error?: string | null;
  showError?: boolean;
  value?: string | number;
  theme?: 'dark' | 'light';
  topPlaceholder?: string;
  className?: string;
  topPlaceholderStyle?: string;
  placeholder?: string;
  placeHolderStyle?: string;
  extraButtonStyle?: string;
  disabled?: boolean;
  wrapperClassname?: string;
  showRemove?: boolean;
  removeFunction?: () => void;
  removeIcon?: React.ReactNode;
  removeStyle?: string;

  style?: React.CSSProperties;
  selectedButtonColor?: string;
  buttoncontentstyle?: string;
  buttonContainerStyle?: string;
  backgroundColorBtn?: string;
  classBtnLi?: string;
  classchildern?: string;

  classButtonText?: string;
  extraInfo?: string;

  guide?: string;
  extraInfoStyle?: string;
  icon?: ReactNode;
  fillIcon?: string;
  iconSize?: string;
  showTitle?: boolean;
  insideWrapperClass?: string;
  boxClass?: string;
  extraActiveStyle?: string;
}

const Select = ({
  list,
  title,
  icon,
  fillFormFunction,
  chooseItem,
  error,
  showError,
  value = '',
  theme = 'light',
  topPlaceholder,
  className = 'nothing',
  topPlaceholderStyle = 'nothing',
  placeholder = '',
  placeHolderStyle,
  extraButtonStyle,
  disabled = false,
  showRemove = false,
  removeFunction,
  removeIcon,
  removeStyle = 'nothing',
  buttonContainerStyle = '',
  style,
  selectedButtonColor = 'transparent',
  buttoncontentstyle = '',
  backgroundColorBtn = '',
  classBtnLi = '',
  classchildern = '',

  classButtonText = '',
  extraInfo = '',
  guide,
  extraInfoStyle = '',
  fillIcon = 'var(--link-color)',
  iconSize = '14px',
  showTitle = true,
  insideWrapperClass = '',
  boxClass = '',
  extraActiveStyle = '',
}: SelectProps) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(0);
  const [optionsList, setOptionsList] = useState<SelectItem[]>([]);
  const [focused, setFocused] = useState('');
  const containerRef = useRef<null | HTMLDivElement>(null);
  const tCommon = useTranslations('common');

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setFocused('');
        setIsOptionsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setOptionsList([{ id: '', title: placeholder, name: placeholder }, ...list]);
  }, [list, placeholder]);

  useEffect(() => {
    if (optionsList.length > 0) {
      const index = optionsList.findIndex((x) => x.id == value);
      setSelectedOption(index === -1 ? 0 : index);
    }
  }, [optionsList, value]);

  const toggleOptions = () => {
    setFocused(focused?.length === 0 ? title || '' : '');
    setIsOptionsOpen(!isOptionsOpen);
  };

  const setSelectedThenCloseDropdown = (index: number) => {
    if (index !== 0) {
      const item = optionsList[index];
      setSelectedOption(index);
      fillFormFunction?.(item.id);
      chooseItem?.(item);
      setIsOptionsOpen(false);
    }
  };

  const handleKeyDown = (index: number) => (e: React.KeyboardEvent) => {
    if (index === 0) return;

    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      setSelectedThenCloseDropdown(index);
    }
  };

  const handleListKeyDown = (e: React.KeyboardEvent) => {
    if (optionsList.length === 0) return;

    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        setIsOptionsOpen(false);
        break;

      case 'ArrowUp':
        e.preventDefault();
        setSelectedOption(selectedOption - 1 >= 0 ? selectedOption - 1 : optionsList.length - 1);
        break;

      case 'ArrowDown':
        e.preventDefault();
        setSelectedOption(selectedOption === optionsList.length - 1 ? 0 : selectedOption + 1);
        break;
    }
  };
  console.log('focused==', focused);
  return (
    <div className={`formItem ${styles.wrapperContainer} ${className}`}>
      {showTitle && title && (
        <div className={`${styles.title} formTitle`}>
          <span>
            {title}
            {extraInfo && <span className={extraInfoStyle}>{extraInfo}</span>}
          </span>
          {guide && RenderHelpBox(title, guide)}
        </div>
      )}

      <div
        className={`${styles.wrapper} ${insideWrapperClass} ${disabled && styles.disabled} ${
          isOptionsOpen && styles.openedButton
        } ${showError && styles.noMargin} `}
      >
        <div className={styles.container} ref={containerRef}>
          <div className={styles.placeholderContainer}>
            {topPlaceholder && (
              <span className={`${styles.placeholder} ${topPlaceholderStyle}`}>
                {topPlaceholder}
              </span>
            )}

            <div
              className={`${styles.buttonContainer} ${theme == 'dark' && styles.darkButtonContainer}  ${
                showError && 'inputError'
              }  ${buttonContainerStyle}`}
            >
              <button
                type="button"
                disabled={disabled}
                aria-haspopup="listbox"
                aria-expanded={isOptionsOpen}
                className={`textTruncationSelect ${styles.button} ${theme == 'dark' && 'darkInput'} ${focused && 'formActiveBorder'} ${
                  isOptionsOpen ? styles.expanded : ''
                } ${optionsList[selectedOption]?.id === '' && placeHolderStyle}  ${
                  showRemove && value !== '' && styles.borderSelectButton
                } ${extraButtonStyle} `}
                onClick={toggleOptions}
                onKeyDown={handleListKeyDown}
                title={optionsList[selectedOption]?.name}
                // placeholder={placeholder || title}
                style={style}
              >
                <div
                  className={`${classButtonText} ${styles.buttonText} ${
                    optionsList[selectedOption]?.id === '' && styles.placeholderColor
                  }`}
                  style={{ minHeight: '20px', maxHeight: '22px' }}
                >
                  <div className={styles.noMargin} style={{ backgroundColor: selectedButtonColor }}>
                    {optionsList[selectedOption]?.title || optionsList[selectedOption]?.name}
                  </div>
                </div>
                {icon ? (
                  icon
                ) : (
                  <MainIcons.arrowIcon
                    width={iconSize}
                    height={iconSize}
                    className={`${styles.arrowIcon} ${isOptionsOpen && styles.arrowIconOpen} arrowIcon`}
                    // className={`${styles.rotate270} ${isOptionsOpen && `${styles.rotate90}`}`}
                    // fill={showError ? 'var(--error-color)' : fillIcon}
                  />
                )}
              </button>

              {showRemove && value !== '' && (
                <div
                  className={`${styles.removeStyle} ${removeStyle}`}
                  onClick={() => {
                    removeFunction?.();
                    setIsOptionsOpen(false);
                    setSelectedOption(0);
                  }}
                >
                  {removeIcon}
                </div>
              )}
            </div>
          </div>

          <ul
            className={`${styles.options} ${styles.ul} ${boxClass} ${isOptionsOpen ? styles.show : ''}`}
            role="listbox"
            aria-activedescendant={String(optionsList[selectedOption]?.name)}
            tabIndex={-1}
            onKeyDown={handleListKeyDown}
          >
            {optionsList.map((option, index) => (
              <li
                className={
                  index === 0
                    ? `${styles.disabled} ${styles.displayNone}`
                    : `${styles.li} ${value === option?.id && `${styles.activeStyle} ${extraActiveStyle}`}`
                }
                id={String(index)}
                key={index}
                role="option"
                aria-selected={selectedOption === index}
                tabIndex={0}
                onKeyDown={handleKeyDown(index)}
                onClick={() => setSelectedThenCloseDropdown(index)}
              >
                <div
                  className={`${classBtnLi} ${styles.noMargin}`}
                  // classchildern={classchildern}
                  style={{
                    backgroundColor: option?.color || backgroundColorBtn,
                  }}
                >
                  {option?.title || option?.name}
                </div>
              </li>
            ))}

            {list?.length === 0 && <p className={styles.empty}>{tCommon('emptyList')}</p>}
          </ul>
        </div>
      </div>

      {showError && <p className="inputErrorText">{error}</p>}
    </div>
  );
};

export default Select;
